package com.wintermar.inspection.feature.presentation.inspection.landing.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.widget.IconText
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_calendar
import inspection.composeapp.generated.resources.ic_vessel
import inspection.composeapp.generated.resources.last_update
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionLandingContentItem(
    templateName: String,
    vesselName: String,
    lastUpdateIso: String,
    dimension: AppDimension = LocalAppTheme.current.dimension,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(
            dimension.spacing.space1
        )
    ) {
        TextBodyRegular(
            text = templateName,
            bold = true
        )

        IconText(
            icon = Res.drawable.ic_vessel,
            text = vesselName
        )

        IconText(
            icon = Res.drawable.ic_calendar,
            text = "${stringResource(Res.string.last_update)} ${
                DateTimeUtil.getLocalSystemDisplayWithTime(
                    lastUpdateIso
                )
            }"
        )
    }
}
